import React from 'react'
import PropTypes from 'prop-types'

const Arrow = ({ stroke = '#222', direction = 'down' }) => (
  <svg
    id='arrow_icon'
    data-name='arrow icon'
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='28'
    viewBox='0 0 28 28'
    className={`arrow ${direction}`}
  >
    <circle id='Ellipse_812' data-name='Ellipse 812' cx='14' cy='14' r='14' fill='#fff' />
    <path
      id='Path_16656'
      data-name='Path 16656'
      d='M0,5.075,5.075,0l5.077,5.075'
      transform='translate(19.076 17.028) rotate(180)'
      fill='none'
      stroke={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)

export default Arrow

Arrow.propTypes = {
  stroke: PropTypes.string,
  direction: PropTypes.string
}
